import { SharedIcon } from "../shared/shared-icon";
import {
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectIcon,
  SelectPortal,
  SelectContent,
  SelectScrollUpButton,
  SelectViewport,
  SelectScrollDownButton,
  SelectItem,
} from "../shared/select";

/**
 * The room a project is tagged with, as one Radix Select used in both places a member picks it:
 * the CREATE PROJECT modal on the list, and the project edit form.
 *
 * Radix rather than a native <select>, because that is what every other picker on this site is —
 * see the room and description fields in CREATE NEW COLLECTION. The classes are the shared
 * shadcn-select ones, so it inherits that appearance rather than growing a second one.
 *
 * The rooms are curated by editors on the site root — the same list the community collections
 * room filter offers, so a member can only tag with a room a visitor can filter by.
 */
export function RoomTypeSelect({ roomTypes, value, onChange, placeholder, labelledBy, testId, className }) {
  return (
    <SelectRoot value={value || undefined} onValueChange={onChange}>
      <SelectTrigger
        className={className ? `shadcn-select-trigger ${className}` : "shadcn-select-trigger"}
        data-testid={testId}
        aria-labelledby={labelledBy}
      >
        <SelectValue className="shadcn-select-value" placeholder={placeholder} />
        <SelectIcon className="shadcn-select-icon">
          <SharedIcon iconName="#sprite-icon-dropdown-arrow" style={{ width: "14px", height: "14px" }} />
        </SelectIcon>
      </SelectTrigger>

      <SelectPortal>
        <SelectContent className="shadcn-select-content">
          <SelectScrollUpButton />
          <SelectViewport className="shadcn-select-viewport">
            {roomTypes.map((roomType) => (
              <SelectItem key={roomType.key} value={roomType.key}>
                {roomType.name}
              </SelectItem>
            ))}
          </SelectViewport>
          <SelectScrollDownButton />
        </SelectContent>
      </SelectPortal>
    </SelectRoot>
  );
}
